import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  BaseApiTemplateService,
  Core2Config,
} from "../shared";
import { PaymentChannelHeadersContainerModel } from "../../../../../models/aggregates/pgw/payment-channel-headers.model";

@Injectable({
  providedIn: "root",
})
export class PaymentChannelHeadersService extends BaseApiTemplateService<PaymentChannelHeadersContainerModel[]> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "paymentchannels/multi";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "paymentchannels/multi";
    this.httpClient = http;
  }

}
